import React, { useState } from 'react';
import s from './CustomKeyBoard.scss';

const CustomKeyBoard = ({ handleKeyPress }) => {
  const handleKeyClick = event => {
    const keyValue = event.target.textContent || event.target.value;
    handleKeyPress(keyValue);
  };

  return (
    <div className={`${s.keypad} keypad`} id="til_crossword_keyboard">
      <ul>
        <li>
          <button type="button" onClick={handleKeyClick}>
            Q
          </button>
          <button type="button" onClick={handleKeyClick}>
            W
          </button>
          <button type="button" onClick={handleKeyClick}>
            E
          </button>
          <button type="button" onClick={handleKeyClick}>
            R
          </button>
          <button type="button" onClick={handleKeyClick}>
            T
          </button>
          <button type="button" onClick={handleKeyClick}>
            Y
          </button>
          <button type="button" onClick={handleKeyClick}>
            U
          </button>
          <button type="button" onClick={handleKeyClick}>
            I
          </button>
          <button type="button" onClick={handleKeyClick}>
            O
          </button>
          <button type="button" onClick={handleKeyClick}>
            P
          </button>
        </li>
        <li>
          <button type="button" onClick={handleKeyClick}>
            A
          </button>
          <button type="button" onClick={handleKeyClick}>
            S
          </button>
          <button type="button" onClick={handleKeyClick}>
            D
          </button>
          <button type="button" onClick={handleKeyClick}>
            F
          </button>
          <button type="button" onClick={handleKeyClick}>
            G
          </button>
          <button type="button" onClick={handleKeyClick}>
            H
          </button>
          <button type="button" onClick={handleKeyClick}>
            J
          </button>
          <button type="button" onClick={handleKeyClick}>
            K
          </button>
          <button type="button" onClick={handleKeyClick}>
            L
          </button>
          <button
            type="button"
            value="deleted"
            className={s.delete}
            onClick={handleKeyClick}
          >
            <div className={s.erase}>
              <i className={s.deleteIcon} />
            </div>
          </button>
        </li>
        <li>
          <button
            type="submit"
            className={s.submit}
            value="submit"
            onClick={handleKeyClick}
          >
            Submit
          </button>
          <button type="button" onClick={handleKeyClick}>
            Z
          </button>
          <button type="button" onClick={handleKeyClick}>
            X
          </button>
          <button type="button" onClick={handleKeyClick}>
            C
          </button>
          <button type="button" onClick={handleKeyClick}>
            V
          </button>
          <button type="button" onClick={handleKeyClick}>
            B
          </button>
          <button type="button" onClick={handleKeyClick}>
            N
          </button>
          <button type="button" onClick={handleKeyClick}>
            M
          </button>
          <button
            value="space"
            type="button"
            className={s.space}
            onClick={handleKeyClick}
          >
            <i className={s.spaceIcon} />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default CustomKeyBoard;
